import type { TonoEstado } from './estado-legajo';
import type { EstadoPadron } from './types';

export interface EstadoPadronInfo {
  label: string;
  descripcion: string;
  tono: TonoEstado;
}

/**
 * Catálogo ÚNICO de los estados del PADRÓN (el archivo cargado), hermano de
 * `estado-legajo.ts`. De acá salen el badge de la tabla y las opciones del
 * filtro: si estuvieran duplicados, agregar un estado nuevo dejaría el filtro
 * sin esa opción y nadie se enteraría hasta que un padrón "desaparezca".
 *
 * El `Record` está tipado por `EstadoPadron`, así que sumar un estado al union
 * de `types.ts` sin darle entrada acá NO compila. `estado-padron.spec.ts` ata
 * además que `ESTADOS_PADRON` liste todas las claves.
 *
 * OJO — no confundir con el estado del LEGAJO. Un padrón `cerrado` puede tener
 * legajos en `pendiente_validacion_medicus` adentro (pasa cuando un legajo se
 * valida o se crea después del cierre). Buscar esos legajos filtrando padrones
 * "pendiente validación" no los encuentra: hay que entrar al padrón cerrado.
 * Por eso la descripción de `cerrado` lo dice explícito.
 */
export const ESTADO_PADRON: Record<EstadoPadron, EstadoPadronInfo> = {
  borrador: {
    label: 'Borrador',
    descripcion: 'Se cargó el archivo pero todavía no se cerró; aún no generó legajos.',
    tono: 'neutral',
  },
  pendiente_validacion: {
    label: 'Pendiente de validación',
    descripcion: 'La empresa lo cerró y espera que Medicus lo valide.',
    tono: 'warning',
  },
  cerrado: {
    label: 'Cerrado',
    descripcion:
      'Validado y con los legajos creados. Ojo: puede tener legajos pendientes de validación adentro — se ven en la pestaña Legajos del padrón.',
    tono: 'info',
  },
};

/** Orden en que se ofrecen los estados (del más "en curso" al más terminado). */
export const ESTADOS_PADRON: EstadoPadron[] = ['borrador', 'pendiente_validacion', 'cerrado'];

/** Info del estado, con fallback seguro para valores desconocidos. */
export function estadoPadronInfo(estado: string): EstadoPadronInfo {
  return (
    ESTADO_PADRON[estado as EstadoPadron] ?? {
      label: estado,
      descripcion: 'Estado no reconocido.',
      tono: 'neutral',
    }
  );
}
